const getAcidMass = (mass) => (mass === "kg" ? 4032000 : 8870400);
const getAlkaliMass = (mass) => (mass === "kg" ? 7200000 : 15840000);
const getMaxMass = (mass) => (mass === "kg" ? 100 : 220);
const getMinTemp = (temperature) => (temperature === "C" ? 20 : 68);
const getMaxTemp = (temperature) => (temperature === "C" ? 100 : 212);

export const Default_CIP_INFORMATION = (temperature, mass) => {
  return {
    acid: {
      acid_used_per_cip: {
        key: "acid_used_per_cip",
        ranges: {
          hard: {
            min: 0,
            max: getAcidMass(mass),
          },
        },
        unit: mass,
      },
      acid_cip_ph: {
        key: "acid_cip_ph",
        ranges: { hard: { min: 1, max: 7 } },
        unit: "pH",
      },
      acid_cip_temp: {
        key: "acid_cip_temp",
        ranges: {
          hard: {
            min: getMinTemp(temperature),
            max: getMaxTemp(temperature),
          },
        },
        unit: `\u00B0${temperature}`,
      },
      acid_cip_duration: {
        key: "acid_cip_duration",
        ranges: { hard: { min: 1, max: 48 } },
        unit: "hrs",
      },
    },
    alkali: {
      alkali_used_per_cip: {
        key: "alkali_used_per_cip",
        ranges: {
          hard: {
            min: 0,
            max: getAlkaliMass(mass),
          },
        },
        unit: mass,
      },
      alkali_cip_ph: {
        key: "alkali_cip_ph",
        ranges: { hard: { min: 7, max: 14 } },
        unit: "pH",
      },
      alkali_cip_temp: {
        key: "alkali_cip_temp",
        ranges: {
          hard: {
            min: getMinTemp(temperature),
            max: getMaxTemp(temperature),
          },
        },
        unit: `\u00B0${temperature}`,
      },
      alkali_cip_duration: {
        key: "alkali_cip_duration",
        ranges: { hard: { min: 1, max: 48 } },
        unit: "hrs",
      },
    },
    solution: {
      additional_chemical_per_cip: {
        key: "additional_chemical_per_cip",
        ranges: {
          hard: {
            min: 0,
            max: getMaxMass(mass),
          },
        },
        unit: mass,
      },
      cip_solution_ph: {
        key: "cip_solution_ph",
        ranges: { hard: { min: 1, max: 14 } },
        unit: "pH",
      },
      cip_solution_temp: {
        key: "cip_solution_temp",
        ranges: {
          hard: {
            min: getMinTemp(temperature),
            max: getMaxTemp(temperature),
          },
        },
        unit: `\u00B0${temperature}`,
      },
      cip_solution_duration: {
        key: "cip_solution_duration",
        ranges: { hard: { min: 1, max: 48 } },
        unit: "hrs",
      },
    },
  };
};

export const PLANT_DETAILS = () => {
  return {
    add: {
      add_info: {
        key: "add_info",
        multiline: "2",
        maxChar: 500,
      },
    },
  };
};

export const INITIAL_DEFAULT_CIP_ERROR_STATE = {
  acid_used_per_cip: null,
  alkali_used_per_cip: null,
  additional_chemical_per_cip: null,
  acid_cip_ph: null,
  alkali_cip_ph: null,
  cip_solution_ph: null,
  acid_cip_temp: null,
  alkali_cip_temp: null,
  cip_solution_temp: null,
  acid_cip_duration: null,
  alkali_cip_duration: null,
  cip_solution_duration: null,
};
